// Module
var code = `<div appHeaderBar>
    <header-bar-title>View Schedule</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true" *ngIf="doneLoading">

    <app-cobrand-header [property]="property.nickname"
                        [manager]="property.hoa.pmc.name"
                        [association]="property.hoa.name">
    </app-cobrand-header>

    <form name="PaymentScheduleView" id="PaymentScheduleView" tid="PaymentScheduleView" #paymentScheduleView="ngForm">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <div class="HOA-container__header-text" tid="scheduleNicknameHeader">
                    <span>{{paymentSchedule.nickname}} ({{paymentSchedule.frequency}})</span>
                </div>
                <button name="back"
                        id="back"
                        tid="back"
                        type="button"
                        class="Button Button--link"
                        [routerLink]="['/properties/scheduleEdit', paymentSchedule.id]"
                        [state]="{scheduleId: paymentSchedule.id}">
                    Back
                </button>
            </div>
            <div class="HOA-container__content">
                <div class="HOA-flex-component
                                    HOA-flextable-component__lg-space-between
                                    HOA-view-schedule-inline-detail
                                    HOA-propertyblock-flextable__cell">
                    <div class="HOA-propertylanding-content__subheader
                                        HOA-propertyblock-flextable__cell--100">
                        Scheduled Payments
                    </div>
                </div>

                <div class="HOA-flextable-component HOA-flextable-component__cell-100">
                    <div class="HOA-flex-component HOA-flextable-component__cell-100 u-pH4">
                        <div class="HOA-flextable-component__cell--header-noBasis">
                            <div class="HOA-flextable-component__cell-label
                                                HOA-flex-center-info-button
                                                HOA-flextable-component__cell-label--taller">
                                <span>Payment Date&nbsp;</span>
                                <button type="button"
                                        tid="paymentDateHelper"
                                        id="paymentDateHelper"
                                        class="u-posRelative HOA-flex-center-info-button"
                                        (click)="paymentDatedHelper()">
                                            <span class="Icon Icon--24 u-iconBlue">
                                                <svg focusable="false"
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     width="24"
                                                     height="24"
                                                     viewBox="0 0 72 72">
                                                    <title>Payment Date</title>
                                                    <path class="stroke_layer"
                                                          d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                                          fill="none"
                                                          stroke="#838383"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                          stroke-width="3.8">
                                                    </path>
                                                    <path class="fill_layer"
                                                          d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                          fill="#838383"
                                                          stroke-width="3.8">
                                                    </path>
                                                    <path class="stroke_layer"
                                                          data-name="stroke_layer"
                                                          d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3 0 0 0-.1 1.7v2.6"
                                                          fill="none"
                                                          stroke="#838383"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                          stroke-width="3.8">
                                                    </path>
                                                </svg>
                                            </span>
                                </button>
                            </div>
                        </div>
                        <div class="HOA-flextable-component__cell--header-noBasis
                                            HOA-flextable-component__cell-center">
                            <div class="HOA-flextable-component__cell-label
                                                HOA-flextable-component__cell-label--taller">
                                Amount
                            </div>
                        </div>
                        <div class="HOA-flextable-component__cell--header-noBasis
                                            HOA-flextable-component__cell-center">
                            <div class="HOA-flextable-component__cell-label
                                                HOA-flextable-component__cell-label--taller">
                                Status
                            </div>
                        </div>
                    </div>
                    <!-- table repeat -->
                    <div *ngFor="let futurePayment of sortedFuturePayments"
                         class="HOA-flextable-component
                                        HOA-flextable-component__cell-100
                                        HOA-payment-schedule-hrule-last__parent">
                        <div class="HOA-flex-component HOA-flextable-component__cell-100 u-mH4">
                            <div class="HOA-payment-schedule__cell
                                                HOA-flextable-component__cell--pV12
                                                HOA-flextable-component__cell-value"
                                 tid="scheduleDate">
                                        <span *ngIf="paymentSchedule.type !== 'account-balance'">
                                            <a  [routerLink]="['/properties/paymentEdit', paymentSchedule.id, futurePayment.id]"
                                                [state]="{scheduleId: paymentSchedule.id,
                                                            paymentId: futurePayment.id,
                                                            paymentMethod: paymentSchedule.paymentMethod}">
                                                {{futurePayment.date.formattedFullDate}}
                                            </a>
                                        </span>
                                <span *ngIf="paymentSchedule.type === 'account-balance'">
                                            {{futurePayment.date.formattedFullDate}}
                                        </span>
                            </div>
                            <div class="HOA-payment-schedule__cell--center
                                                HOA-flextable-component__cell--pV12
                                                HOA-flextable-component__cell-value"
                                 tid="scheduleAmount">
                                 <span *ngIf="paymentSchedule.type !== 'account-balance'">
                                    {{(futurePayment.total | currency)}}
                                </span>
                                <span *ngIf="paymentSchedule.type === 'account-balance'">
                                    {{"Next Assessment Amount"}}
                                </span>
                            </div>
                            <div class="HOA-payment-schedule__cell--center
                                                HOA-flextable-component__cell--pV12
                                                HOA-flextable-component__cell-value
                                                capitalize"
                                 tid="status" [ngSwitch]="futurePayment.status">
                                        <span *ngSwitchCase="'scheduled'">
                                            {{futurePayment.status}}
                                            <a (click)="cancelPayment(futurePayment)">Cancel</a>
                                        </span>
                                <span *ngSwitchCase="'cancelled'">
                                            {{futurePayment.status}}
                                    <a (click)="restorePayment(futurePayment)">Restore</a>
                                        </span>
                                <span *ngSwitchCase="'cancelled-by-CSR'">
                                            Cancelled by CSR
                                            <a (click)="restorePayment(futurePayment)">Restore</a>
                                        </span>
                                <span *ngSwitchCase="'cancelled-by-user'">
                                            Cancelled by User
                                            <a (click)="restorePayment(futurePayment)">Restore</a>
                                        </span>
                            </div>
                        </div>
                    </div>
                    <!-- end repeat -->
                </div>
                <div class="HOA-view-schedule-detail
                                    HOA-font-fine-print
                                    u-app-hide-if-size-is-phone
                                    Box-footer--separate
                                    Grid--alignCenter">
                    Scheduled payments dated for a weekend or holiday will be processed the prior business day.
                </div>
                <div class="u-pT5 HOA-Checking-Detail-button-container">
                    <button name="cancel"
                            id="cancel"
                            tid="cancel"
                            type="button"
                            class="Button Button--link "
                            [routerLink]="['/properties/scheduleEdit', paymentSchedule.id]"
                            [state]="{scheduleId: paymentSchedule.id}">
                        Back
                    </button>
                </div>
            </div>
        </div>
    </form>
    <div class="HOA-remove-button-container">
        <button name="submitDelete"
                id="submitDelete"
                tid="submitDelete"
                type="submit"
                class="Button Button--outline"
                (click)="removeSchedule()">
            Delete Schedule
        </button>
    </div>
</app-page-content>`;
// Exports
module.exports = code;